export const PRINT_CHART_WIDTH = 910;
